import { render, staticRenderFns } from "./detalles.vue?vue&type=template&id=04a3ba7c&scoped=true"
import script from "./detalles.vue?vue&type=script&lang=js"
export * from "./detalles.vue?vue&type=script&lang=js"
import style0 from "./detalles.vue?vue&type=style&index=0&id=04a3ba7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3ba7c",
  null
  
)

export default component.exports